import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Panneau latéral de détail (cahier des charges §4) : la liste reste visible
 * derrière, le panneau a sa propre URL. Fermer revient à la liste.
 */
export function Drawer({
  title,
  subtitle,
  badges,
  actions,
  onClose,
  children,
  label,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  badges?: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  /** Nom accessible quand le titre n'est pas du texte simple. */
  label?: string;
}) {
  return (
    <Dialog.Root open onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="drawer__overlay" />
        <Dialog.Content className="drawer" aria-describedby={undefined} aria-label={label}>
          <div className="drawer__header">
            <div className="drawer__heading">
              <Dialog.Title className="drawer__title">{title}</Dialog.Title>
              {subtitle && <div className="drawer__subtitle">{subtitle}</div>}
              {badges && <div className="drawer__badges">{badges}</div>}
            </div>
            <div className="drawer__header-actions">
              {actions}
              <Dialog.Close className="icon-btn" aria-label="Fermer le panneau">
                <X size={18} aria-hidden="true" />
              </Dialog.Close>
            </div>
          </div>
          <div className="drawer__body">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
